import Http from "@/config/axios.js"
import {to} from "await-to-js"

export default {
    async list(params) {
        return to(Http(window.API_PREFIX + "/tickets", {params}))
    },
    async get(id) {
        return to(Http(window.API_PREFIX + `/tickets/${id}`))
    },
    async create(params) {
        return to(Http(window.API_PREFIX + `/tickets/create`, {params}))
    },
    async edit(id, params) {
        return to(Http(window.API_PREFIX + `/tickets/${id}/edit`, {params}))
    },
    async insert(data) {
        return to(Http.post(window.API_PREFIX + `/tickets`, data))
    },
    async update(id, data) {
        data.append('_method', 'patch')
        return to(Http.post(window.API_PREFIX + `/tickets/${id}`, data))
    },
    async save(data, id) {
        return id ? this.update(id, data) : this.insert(data)
    },
}

